export default "__VITE_ASSET__C0UrS7Ge__"